if (!customElements.get('app-shipbob')) {
  class SectionShipbob extends HTMLElement {
    constructor() {
      super();
      const clientId = 'ExternalApplication_22c30ffc-523a-4c11-a888-355438645799';
      const baseUri = 'https://auth.shipbob.com/connect/authorize';
      const redirectUri = encodeURIComponent(`https://arka.com/shipbobauth`);

      this.loginLink = `${baseUri}?client_id=${clientId}&scope=channels_read orders_read orders_write products_read products_write receiving_read receiving_write offline_access&redirect_uri=${redirectUri}`;
      this.queryString = window.location.search;
      this.url = window.location.href;
      this.urlParams = new URLSearchParams(this.queryString);
      this.buttonShipbo = this.querySelector('.connect-shipbob')
      if(this.buttonShipbo){
        this.buttonShipbo.addEventListener('click',e=>{
          e.preventDefault();
          if(this.setNotlogged()){
            window.location.replace(this.loginLink);
          }
        })
      }
    }

    setNotlogged(){
      let val = true;
      if(this.dataset.user == ''){
        const tempUrl = new URL(this.url);
        let url = `${tempUrl.protocol}//${tempUrl.host}/pages/shipbob`
        localStorage.setItem('urlReturn',url.replace(`${tempUrl.protocol}//${tempUrl.host}`,''));
        localStorage.setItem('isLogged','shipbob');
        localStorage.setItem('actionLogged','redirection');
        window.location.replace("/account");
        val = false;
      }
      return val;
    }
  }

  customElements.define('app-shipbob', SectionShipbob);
}
